module.exports = __webpack_public_path__ + "img/20201102-1.df447b4d.jpg";